import React, { createContext, useContext } from 'react';
import { useGetTokenFromUrl, useGetTripInfoModification, useLowCost } from "../../clientState/hooks";
const ModificationTripInfoContext = /*#__PURE__*/createContext(null);
export function useModificationTripInfo() {
  const tripInfo = useContext(ModificationTripInfoContext);
  if (tripInfo !== false && typeof tripInfo !== 'object') {
    throw new Error('No ModificationTripInfoProvider found');
  }
  return tripInfo;
}
const ModificationTripInfoProvider = ({
  children
}) => {
  const token = useGetTokenFromUrl();
  const {
    data,
    errors,
    loading
  } = useGetTripInfoModification({
    token
  });
  const isLowCost = useLowCost();
  const {
    getTripByToken: {
      trip: {
        id: bookingId,
        creationDate,
        price,
        buyer: {
          mail: email,
          name,
          phoneNumber: {
            number: phoneNum
          }
        },
        itinerary: {
          bookingItemId,
          legs,
          itineraryType,
          tripType
        },
        travellers,
        insuranceBookings: {
          bookings: insurances
        }
      },
      userMembership: {
        isActive: isPrime
      }
    }
  } = data || {
    getTripByToken: {
      trip: {
        price: {},
        buyer: {
          phoneNumber: {}
        },
        itinerary: {
          legs: []
        },
        travellers: [],
        insuranceBookings: {
          bookings: []
        }
      },
      userMembership: {}
    }
  };
  return /*#__PURE__*/React.createElement(ModificationTripInfoContext.Provider, {
    value: {
      bookingId,
      email,
      name,
      phoneNum,
      isPrime,
      price,
      bookingItemId,
      creationDate,
      legs,
      isLowCost,
      errors,
      loading,
      travellers,
      insurances,
      itineraryType,
      tripType
    }
  }, children);
};
export default ModificationTripInfoProvider;